/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./asset-dialog-trigger.vue?vue&type=template&id=853254ce&scoped=true&"
import script from "./asset-dialog-trigger.vue?vue&type=script&lang=ts&"
export * from "./asset-dialog-trigger.vue?vue&type=script&lang=ts&"
import style0 from "./asset-dialog-trigger.vue?vue&type=style&index=0&id=853254ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853254ce",
  null
  
)

export default component.exports